const AddEditAlertGroupsParamsDefinitions = [
  {
    section: 'groupDetails',
    tag: 'groupName',
    label: 'Group Name',
    type: 'text',
  },
  {
    section: 'groupDetails',
    tag: 'unitPrefs',
    label: 'Units',
    type: 'dropDown',
    dropDownOptions: [],
  },
  {
    section: 'distributionList',
    tag: 'emailInput',
    label: 'Email',
    type: 'custom',
  },
  {
    section: 'distributionList',
    tag: 'distributionList',
    label: 'Recipients',
    type: 'custom',
  },
  {
    section: 'selections',
    tag: 'rigs',
    label: 'Rigs',
    type: 'custom',
  },
  {
    section: 'selections',
    tag: 'operators',
    label: 'Operators',
    type: 'custom',
  },
]

export function getDetails(form, units, duplicateGroupName, renderers = {}) {
  const details = {
    groupDetails: [],
    distributionList: [],
    selections: [],
  }

  if (!form || typeof form !== 'object') return details

  AddEditAlertGroupsParamsDefinitions.forEach((field, index) => {
    const value = form[field.tag] === undefined || form[field.tag] === null ? '' : form[field.tag]

    details[field.section].push({
      ...field,
      id: index,
      value,
      ...(field.tag === 'unitPrefs' && {
        dropDownOptions: units ?? [],
      }),
      ...(field.tag === 'groupName' && {
        error: duplicateGroupName,
        helperText: duplicateGroupName ? 'Group name already exists' : '',
      }),
      ...(field.type === 'custom' && {
        render: renderers[field.tag],
      }),
    })
  })

  return details
}

export default AddEditAlertGroupsParamsDefinitions
